import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { FormUtilsService } from 'src/app/shared/services/form-utils.service';
import { Restriction } from '../../models/Restriction';
import { PortalUserService } from '../../services/portalUser.service';

@Component({
  selector: 'app-add-user-restriction',
  templateUrl: './add-user-restriction.component.html',
  styleUrls: ['./add-user-restriction.component.scss']
})
export class AddUserRestrictionComponent extends DialogContentBase implements OnInit {

  constructor(public dialog: DialogRef,
    private fb: UntypedFormBuilder,
    private userService: PortalUserService,
    private formUtilsService: FormUtilsService,
    public uiNotification: UiNotificationService,
    private translateService: TranslateService) {
    super(dialog);
  }

  ngOnInit(): void {
    this.initForm();
  }

  restrictionsList$: Observable<Restriction[]>;
  @Input() public excludeRestrictions: number[];
  @Input() public userId: string;

  assignRestrictionForm: UntypedFormGroup;

  initForm(): void {
    this.assignRestrictionForm = this.fb.group({
      restrictionId: [0, [Validators.required]]
    });

    this.restrictionsList$ = this.userService.getAllRestrictions().pipe(
      map(x => x.filter(r => !this.excludeRestrictions.includes(r.id))),
      tap(x => x.forEach(r => r.description = this.translateService.instant(r.description)))
    );
  }

  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }

  confirm() {
    if (!this.formUtilsService.markFormGroupTouched(this.assignRestrictionForm)) {
      this.uiNotification.showValidationError();
      return;
    }

    const restrictionId = this.assignRestrictionForm.value.restrictionId;

    this.userService.addUserRestriction(this.userId, restrictionId).subscribe(
      () => {
        this.uiNotification.showSuccess('validations.userRestrictionsUpdated');
        this.dialog.close({ text: 'OK' });
      }
    );
  }
}
